import React from 'react';
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { VisitasHistorialDto } from '../../../types/visitas';

interface VisitaHistorialDialogProps {
  open: boolean;
  loading?: boolean;
  visitaId?: number | null;
  items: VisitasHistorialDto[];
  onClose: () => void;
}

const formatDateTime = (value?: string | null): string => {
  if (!value) return '-';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return value;
  return d.toLocaleString('es-AR');
};

const VisitaHistorialDialog: React.FC<VisitaHistorialDialogProps> = ({
  open,
  loading = false,
  visitaId,
  items,
  onClose,
}) => (
  <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
    <DialogTitle>Historial de visita #{visitaId}</DialogTitle>
    <DialogContent dividers>
      {loading ? (
        <CircularProgress />
      ) : items.length === 0 ? (
        <Typography variant="body2" color="text.secondary">
          No hay historial para mostrar.
        </Typography>
      ) : (
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Fecha/Hora</TableCell>
              <TableCell>Estado Anterior</TableCell>
              <TableCell>Estado Nuevo</TableCell>
              <TableCell>Usuario</TableCell>
              <TableCell>Origen</TableCell>
              <TableCell>Observación</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {items.map((row) => (
              <TableRow key={row.idVisitaHistorial}>
                <TableCell>{formatDateTime(row.fechaHoraCambio)}</TableCell>
                <TableCell>{row.estadoAnterior || '-'}</TableCell>
                <TableCell>{row.estadoNuevo}</TableCell>
                <TableCell>{row.usuario || '-'}</TableCell>
                <TableCell>{row.origen || '-'}</TableCell>
                <TableCell>{row.observacion || '-'}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>Cerrar</Button>
    </DialogActions>
  </Dialog>
);

export default VisitaHistorialDialog;
